// extracted by mini-css-extract-plugin
export var button = "GarminSettings-module__button___yKOFk";
export var disabled = "GarminSettings-module__disabled___TX4r8";
export var loading = "GarminSettings-module__loading___Cb0lK";